import {
  Button,
  EHeadingStyleVariant,
  ETextStyleVariant,
  Heading,
  Text,
} from '@outdoorsyco/bonfire';
import Image from 'next/image';
import React from 'react';
import { FormattedMessage, useIntl } from 'react-intl';

import BestSummerJob from '@/assets/generations-in-the-wild/best-summer-job.jpg';
import Jen from '@/assets/generations-in-the-wild/jen.jpg';
import MillionTrips from '@/assets/generations-in-the-wild/million-trips.jpg';

export const OutdoorsyAchievements = () => {
  const intl = useIntl();
  const achievements = [
    {
      image: BestSummerJob,
      title: intl.formatMessage({ defaultMessage: "America's Best Summer Job", id: '0iImy0' }),
      imageAlt: intl.formatMessage({ defaultMessage: "America's Best Summer Job", id: '0iImy0' }),
      description: intl.formatMessage({
        defaultMessage: 'An intrepid family takes our research on the road this summer',
        id: 'sLg28W',
      }),
      buttonLabel: intl.formatMessage({ defaultMessage: 'Apply', id: 'EWw/tK' }),
      buttonUrl: 'https://www.outdoorsy.com/bestsummerjob',
    },
    {
      image: Jen,
      title: intl.formatMessage({
        defaultMessage: 'Pioneering outdoor entrepreneurship',
        id: '93JYJb',
      }),
      imageAlt: intl.formatMessage({
        defaultMessage: 'Pioneering outdoor entrepreneurship',
        id: '93JYJb',
      }),
      description: intl.formatMessage({
        defaultMessage:
          'Inc. acknowledges how Outdoorsy Co-Founder Jen Young is building a generational company',
        id: 'WM4knJ',
      }),
      buttonLabel: intl.formatMessage({ defaultMessage: 'Learn more', id: 'TdTXXf' }),
      buttonUrl: 'https://www.inc.com/profile/jen-young',
    },
    {
      image: MillionTrips,
      title: intl.formatMessage({
        defaultMessage: '7m nights, 1m trips and counting',
        id: '8UAFKE',
      }),
      imageAlt: intl.formatMessage({
        defaultMessage: 'One million trips and counting',
        id: 'dsx+x0',
      }),
      description: intl.formatMessage({
        defaultMessage: `‘Nights spent outdoors’ is our #1 KPI, how it’s going…`,
        id: 'm8eEOd',
      }),
      buttonLabel: intl.formatMessage({ defaultMessage: 'Keep reading', id: 'kV609x' }),
      buttonUrl:
        'https://www.outdoorsy.com/blog/join-us-in-celebrating-one-million-outdoorsy-trips-and-counting',
    },
  ];
  return (
    <div className="text-center section-spacing">
      <Heading variant={EHeadingStyleVariant.H2} className="mx-auto max-w-60">
        <FormattedMessage defaultMessage="Getting families outdoors since 2015" id="+X8Mfu" />
      </Heading>
      <Text
        variant={ETextStyleVariant.LargeBold}
        className="mx-auto mt-4 max-w-[750px] text-secondary-base">
        <FormattedMessage
          defaultMessage="Outdoory’s mission is to ‘restore our relationship with the outdoors and each other’, here are some updates on how our journey is going so far…"
          id="EAkzqc"
        />
      </Text>

      <div className="mt-16 text-left grid grid-cols-1 sm:grid-cols-3 gap-8">
        {achievements.map((data, idx) => (
          <div key={idx} className="relative">
            <div className="relative">
              <Image src={data.image} alt={data.imageAlt} sizes="100vw" width={380} height={280} />
            </div>

            <div className="mt-8">
              <Heading variant={EHeadingStyleVariant.H5}>{data.title}</Heading>
              <Text variant={ETextStyleVariant.LargeRegular} className="mt-4 text-secondary-base">
                {data.description}
              </Text>
            </div>

            <Button
              href={data.buttonUrl}
              className="mt-6"
              label={data.buttonLabel}
              target="_blank"
            />
          </div>
        ))}
      </div>
    </div>
  );
};
